import React, { FC } from 'react'

// Utils
import { noop } from '@sketch/utils'

// Components
import { Button } from '@sketch/components'

// Styles
import { Text, Modal } from './PartnerSubscriptionDoneModal.styles'

// Types
import { ModalInjectedProps } from 'containers/ModalManager'

interface PartnerSubscriptionDoneModalProps extends ModalInjectedProps {
  onHide: () => void
  workspaceName: string
}

const PartnerSubscriptionDoneModal: FC<PartnerSubscriptionDoneModalProps> = ({
  onHide,
  workspaceName,
}) => {
  const handleClick = () => {
    onHide()
  }
  return (
    <Modal onCancel={noop}>
      <Modal.Header>You’re All Set!</Modal.Header>
      <Modal.Body>
        <Text>
          As a Sketch Partner, you can now manage billing and Editor Seats in “
          {workspaceName}”.
        </Text>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary-untinted" onClick={handleClick}>
          Manage People & Settings
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default PartnerSubscriptionDoneModal
